import moment from 'moment'
import { useState } from 'react'

import Row from '../UploadLogRow'
import styles from './GroupedRow.module.scss'

const GroupedUploadRow = ({
  logGroup,
  handleDownloadData,
  isAdminMode,
  subscriberLabel = 'subscribed guests'
}) => {
  const [isExpanded, setExpanded] = useState(false)

  return (
    <div className={isExpanded ? styles.container : ''}>
      <div className={styles.row} onClick={() => setExpanded(!isExpanded)}>
        <div className={styles.date}>
          {moment(logGroup[0].uploadedOn).format('MMM D')}
        </div>
        <div className={styles.totalUpload}>
          {logGroup.reduce((prev, current) => prev + current.numberOfNewSubscribers, 0)}{' '}
          {subscriberLabel}
        </div>
        <div className={styles.number}>{logGroup.length} logs</div>
        <div className={styles.control}>
          <i></i>
        </div>
      </div>
      {isExpanded &&
        logGroup.map(log => (
          <Row
            {...log}
            key={log.inviteUploadHistoryId}
            handleDownloadData={handleDownloadData}
            isAdminMode={isAdminMode}
          />
        ))}
    </div>
  )
}

export default GroupedUploadRow
